export default "__VITE_ASSET__BuZsFlxf__"